import NextImage, { ImageProps } from 'next/image';
import { useState } from 'react';

type ExtendedImageProps = {
  fallbackSrc?: string;
  src: ImageProps['src'] | undefined;
  transition?: boolean;
} & Omit<ImageProps, 'src' | 'onLoadingComplete' | 'onError'>;

type ImageLoadStatus = 'pending' | 'success' | 'error';

export function Image({
  fallbackSrc = '/images/product_placeholder.png',
  transition = true,
  ...props
}: ExtendedImageProps) {
  const [status, setStatus] = useState<ImageLoadStatus>(() =>
    props.src ? 'pending' : 'error'
  );
  const isPending = status === 'pending';
  const isError = status === 'error';

  return (
    <NextImage
      quality={90}
      placeholder="empty"
      {...props}
      data-fallback-src={fallbackSrc}
      style={{
        opacity: isPending ? '0' : '1',
        transition: transition ? 'opacity 0.2s linear' : undefined,
        ...props.style,
      }}
      src={isError ? fallbackSrc : props.src || fallbackSrc}
      onLoadingComplete={() => {
        if (!isError) {
          setStatus('success');
        }
      }}
      onError={() => setStatus('error')}
    />
  );
}
